import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { parseBuilderText } from "@/app/builder/build-parser";

const builderText =
`"tutorial"
NoRa
BeNnY
MatZecK
#odewn

SeCtIoN
disPlaY
#tsjkl

aNotHer
eXamPle
#mreaz`

const id = 'tutorial-0.0';

const parsed = parseBuilderText(builderText, id);

if (parsed.levelData === null) {
    throw new Error(`Invalid builder text for ${id}`);
}

export const storyTutorialLevelData: StoryLevelData = parsed.levelData;